// personal information usage agreement modal
import { useMutation } from '@apollo/client';
import classNames from 'classnames/bind';
import { IOta } from 'detail/types';
import styles from './index.module.scss';
import { MUTATE_AGREEMENTS } from './mutateAgreements';

const cx = classNames.bind(styles);

interface IProps {
  ota?: IOta;
  isAgreementRequired: boolean;
  naverId: string;
  getRedirectUrl: (bookingUrl: string, fare: number, otaId: string) => string;
  onClose: () => void;
  refetch: () => void;
}

const alertContent =
  '일시적인 오류로 제휴사에 암호화된 식별자를 제공할 수 없습니다.\n잠시 후 다시 시도해 주십시오.';

const confirmContent = `일시적인 오류로 제휴사에 암호화된 식별자를 제공할 수 없습니다.\n예약 후 고객님의 예약내역은 제휴사 홈페이지에서 확인 가능합니다.\n계속 예약을 진행하시려면 확인버튼을 눌러주세요.`;

const errorHandler = (isAgreementRequired: boolean, redirectUrl?: string) => {
  if (isAgreementRequired) {
    alert(alertContent);
  } else if (window.confirm(confirmContent)) {
    if (redirectUrl) window.open(redirectUrl);
  }
};

export default function Agreement({
  ota,
  isAgreementRequired,
  naverId,
  getRedirectUrl,
  onClose,
  refetch,
}: IProps) {
  const [updateNlabelAgreements] = useMutation(MUTATE_AGREEMENTS, {
    onCompleted: ({ updateNlabelAgreements: { isSuccess } }) => {
      if (isSuccess && ota) {
        window.open(getRedirectUrl(ota.bookingUrl, ota.fare, ota.otaId));
        refetch();
      } else {
        errorHandler(
          isAgreementRequired,
          ota && getRedirectUrl(ota.bookingUrl, ota.fare, ota.otaId),
        );
      }
      onClose();
    },
    onError: () => {
      errorHandler(
        isAgreementRequired,
        ota && getRedirectUrl(ota.bookingUrl, ota.fare, ota.otaId),
      );
      onClose();
    },
  });

  return (
    <div className={cx('Modal')}>
      <div className={cx('agreement')}>
        <h5 className={cx('title')}>
          {naverId}님,
          <br />
          제휴사와 정보 연동이 필요합니다!
        </h5>
        <hr />
        <p className={cx('txt')}>
          <strong>
            예약확인, 트래블클럽 등급조회 및 등급에 따른 혜택, 할인쿠폰 등의
            이벤트・혜택 제공을 위해
          </strong>
          &nbsp; 개인 식별이 불가능한 형태의 암호화된 식별자 및 트래블클럽 등급,
          쿠폰 정보가
          <strong>
            &nbsp; 제휴사에 제공되며, 이용목적 달성 시 지체없이 파기합니다.
          </strong>
        </p>
        <p className={cx('txt')}>
          본 동의 거부 시, 네이버 여행상품 MY페이지에서 예약내역 확인 및 이벤트
          혜택 제공이 어렵습니다.
        </p>
        <hr />
        <i className={cx('desc')}>
          선택하신 사항은 네이버 여행상품 MY페이지에서 변경 가능합니다.
        </i>
        <i className={cx('desc')}>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://m.help.naver.com/support/contents/contentsView.help?contentsNo=14290&lang=ko"
          >
            예약정보 제공 가능한 네이버 여행상품 제휴사
          </a>
        </i>
        <div className={cx('btns')}>
          <button
            className={cx('cancel')}
            type="button"
            onClick={() => {
              if (!isAgreementRequired) {
                updateNlabelAgreements({
                  variables: { isAgreed: false, bookingUrl: ota?.bookingUrl },
                });
              } else {
                onClose();
              }
            }}
          >
            거부
          </button>
          <button
            className={cx('confirm')}
            type="button"
            onClick={() => {
              updateNlabelAgreements({
                variables: {
                  isAgreed: true,
                  bookingUrl: ota?.bookingUrl,
                },
              });
            }}
          >
            동의 후 다시 보지 않기
          </button>
        </div>
        <button className={cx('close')} type="button" onClick={onClose} />
      </div>
    </div>
  );
}
